export default __webpack_public_path__ + "static/media/SISTA.41f8041f.svg";